import Icon from '../components/Icon.vue'

Icon.register({"renren":{"width":1536,"height":1792,"paths":[{"d":"M1133 1570q-171 94-368 94-196 0-367-94 138-87 235.5-211t131.5-268q35 144 132.5 268t235.5 211zM638 142v485q0 252-126.5 459.5t-330.5 306.5q-181-215-181-495 0-187 83.5-349.5t229.5-269.5 325-137zM1536 898q0 280-181 495-204-99-330.5-306.5t-126.5-459.5v-485q179 30 325 137t229.5 269.5 83.5 349.5z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/renren.js